import { toast } from "react-toastify";
import { apiRequest } from "../util/apiUtils";

export const mediaList = async (params) => {
  try {
    const res = await apiRequest("get", `media/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const mediaAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `media/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const mediaDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `media/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const mediaStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `media/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const mediaOrdering = async (payload) => {
  try {
    const res = await apiRequest("patch", `media/ordering`, {
      body: payload,
    });
    toast.success("Media ordering updated successfully");
    return res?.data;
  } catch (err) {
    throw err;
  }
};
